import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { type BadgeProps } from './Badge';

type BadgeDotProps = ComponentProps<'div'> & Pick<BadgeProps, 'type' | 'size'>;

export default function BadgeDot({ type, size, className, ...props }: BadgeDotProps) {
  return (
    <span
      className={cn(
        'flex size-6 w-4 shrink-0 items-center justify-center pl-0.5',
        {
          'size-4.5 w-3.5': size === 'sm',
          'size-3.5 w-2.5': size === 'xs',
        },
        className,
      )}
      {...props}>
      <svg
        viewBox="0 0 10 10"
        className={cn('h-[58%] w-auto', 'fill-zumthor-500', {
          'fill-lynch-50': type === 'standard',
          'fill-fair-pink-600': type === 'dangerous',
          'fill-mantis-50': type === 'success',
          'fill-quarter-spanish-white-700': type === 'warning',
          'fill-quarter-spanish-white-600': type === 'high',
          'fill-quarter-spanish-white-400': type === 'medium',
          'fill-quarter-spanish-white-200': type === 'low',
        })}>
        <circle r="2" cx="5" cy="5" />
      </svg>
    </span>
  );
}
